import {
  GET_CUSTOMER_INCIDENTS,
  GET_CUSTOMER_INCIDENTS_SUCCESS,
  GET_CUSTOMER_INCIDENTS_ERROR,
  GET_TIMEFRAME_REPORTING_DATA,
  GET_TIMEFRAME_REPORTING_DATA_SUCCESS,
  GET_TIMEFRAME_REPORTING_DATA_ERROR,
  CREATE_CUSTOMER_INCIDENTS,
  CREATE_CUSTOMER_INCIDENTS_SUCCESS,
  CREATE_CUSTOMER_INCIDENTS_ERROR,
} from './actionTypes';


export const getCustomerIncidents = (payload) => ({
  type: GET_CUSTOMER_INCIDENTS,
  payload: payload
});

export const getCustomerIncidentsSuccess = (payload) => ({
  type: GET_CUSTOMER_INCIDENTS_SUCCESS,
  payload: payload,
});

export const getCustomerIncidentsError = (error) => ({
  type: GET_CUSTOMER_INCIDENTS_ERROR,
  payload: error,
});

export const createCustomerIncidents = (payload) => ({
  type: CREATE_CUSTOMER_INCIDENTS,
  payload: payload
});

export const createCustomerIncidentsSuccess = (payload) => ({
  type: CREATE_CUSTOMER_INCIDENTS_SUCCESS,
  payload: payload,
});

export const createCustomerIncidentsError = (error) => ({
  type: CREATE_CUSTOMER_INCIDENTS_ERROR,
  payload: error,
});

export const getTimeframeReportingData = (payload) => ({
  type: GET_TIMEFRAME_REPORTING_DATA,
  payload: payload
});

export const getTimeframeReportingDataSuccess = (payload, profilingTagId) => ({
  type: GET_TIMEFRAME_REPORTING_DATA_SUCCESS,
  payload: payload,
  profilingTagId: profilingTagId
});

export const getTimeframeReportingDataError = (error) => ({
  type: GET_TIMEFRAME_REPORTING_DATA_ERROR,
  payload: error,
});